"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeTrackedObjectIdentifier = serializeTrackedObjectIdentifier;
exports.connectionIdentifiersEqual = connectionIdentifiersEqual;
exports.labelIdentifiersEqual = labelIdentifiersEqual;
function serializeTrackedObjectIdentifier(identifier) {
    if (identifier.type === 'connection') {
        const conn = identifier.connection;
        const moduleId = conn.moduleRef || conn.moduleName || 'unknown';
        return `conn:${conn.instancePathId}::${moduleId}::${conn.pinRef}`;
    }
    else {
        const label = identifier.label;
        return `label:${label.instancePathId}::${label.labelType}::${label.originalLabel}::${label.position[0]},${label.position[1]}`;
    }
}
function connectionIdentifiersEqual(a, b) {
    if (a.moduleRef && b.moduleRef) {
        return a.moduleRef === b.moduleRef && a.pinRef === b.pinRef && a.instancePathId === b.instancePathId;
    }
    if (a.moduleName && b.moduleName) {
        return a.moduleName === b.moduleName && a.pinRef === b.pinRef && a.instancePathId === b.instancePathId;
    }
    return false;
}
function labelIdentifiersEqual(a, b) {
    return (a.labelType === b.labelType &&
        a.originalLabel === b.originalLabel &&
        a.instancePathId === b.instancePathId &&
        a.position[0] === b.position[0] &&
        a.position[1] === b.position[1]);
}
//# sourceMappingURL=NetNamingDebugInfo.js.map